<template>
<div class="no-scroll-content" >
    <!-- <vx-card class="no-scroll-content" title="List of Filed Loans" > -->
        <!-- <vs-input class='hidden' v-model="employeeLoan" /> -->
        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <!-- <vs-button type="gradient" @click="promptAddNewLoan()" icon-pack="feather" icon="icon-file">Apply Loan</vs-button> -->
        <vs-table class="no-scroll-content" stripe max-items="12" pagination v-model="selected"  search  :data="employeeLoan">

            <template slot="thead">
                <vs-th sort-key="createdOn">Date Applied</vs-th>
                <vs-th sort-key="loansCategoryId">Category</vs-th>
                <vs-th sort-key="loansSubCategoryId">Sub-Category</vs-th>
                <vs-th>Loan Amount</vs-th>
                <vs-th sort-key="termsTypeId">Terms Type</vs-th>
                <vs-th >Terms</vs-th>
                <vs-th>Reason</vs-th>
                <vs-th>Employee</vs-th>
                <vs-th>Reviewer</vs-th>
                <vs-th>Approver</vs-th>
                <vs-th><vs-icon  color="primary" icon-pack="feather" icon="icon-paperclip"  /></vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Reviewer Comment</vs-th>
                <vs-th>Actions</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].createdOn">
                        {{data[indextr].createdOn | fulldate}}
                    </vs-td>
                    <vs-td :data="data[indextr].loanCategoryId">
                        {{ loanCategoryName(data[indextr].loanCategoryId).loanCategoryName }}
                    </vs-td>
                    <vs-td :data="data[indextr].loanSubCategoryId">
                        {{ loanSubCategoryName(data[indextr].loanSubCategoryId).loanSubCategoryName }}
                    </vs-td>
                    <vs-td :data="data[indextr].loanAmount">
                        {{data[indextr].loanAmount }}
                    </vs-td>
                    <vs-td :data="data[indextr].periodId">
                        {{ periodName(data[indextr].periodId).periodName}}
                    </vs-td>
                    <vs-td :data="data[indextr].loanTerms">
                        {{data[indextr].loanTerms}}
                    </vs-td>
                    <vs-td :data="data[indextr].reason">
                        {{data[indextr].reason}}
                    </vs-td>
                    <vs-td style="width:50px" :data="data[indextr].userId">
                        <vx-tooltip v-bind:text="data[indextr].user.fullName">
                            <div v-if="data[indextr].user.photoUrl !== ''"><vs-avatar  class="rounded-full shadow-md cursor-pointer block" size="30px" :src="data[indextr].user.photoUrl" /></div>
                            <div v-else><vs-avatar  class="rounded-full shadow-md cursor-pointer block" size="30px" :text="data[indextr].user.fullName" :color="data[indextr].user.fullName.length < 12 ? 'success' : data[indextr].user.fullName.length <= 15 ? 'primary' : data[indextr].user.fullName.length <= 20 ? 'warning' : 'danger'" /></div>
                        </vx-tooltip>
                    </vs-td>
                    <vs-td :data="data[indextr].reviewerId">
                        <vx-tooltip v-bind:text="data[indextr].reviewer.fullName">
                             <div v-if="data[indextr].reviewer.photoUrl != ''"><vs-avatar  class="border-2 border-white border-solid -m-1" size="30px" :src="data[indextr].reviewer.photoUrl" /></div>
                            <div v-else><vs-avatar  class="border-2 border-white border-solid -m-1" size="30px" :text="data[indextr].reviewer.fullName" :color="data[indextr].reviewer.fullName.length < 12 ? 'success' : data[indextr].reviewer.fullName.length <= 15 ? 'primary' : data[indextr].reviewer.fullName.length <= 20 ? 'warning' : 'danger'" /></div>
                            
                            <!-- <vs-avatar class="rounded-full shadow-md cursor-pointer block" size="medium" :src="data[indextr].reviewer.photoUrl" /> -->
                        </vx-tooltip>
                    </vs-td>
                    
                    <vs-td :data="data[indextr].approverId">
                        <vx-tooltip v-bind:text="data[indextr].approver.fullName">
                            <div v-if="data[indextr].approver.photoUrl !== ''"><vs-avatar  class="border-2 border-white border-solid -m-1" size="30px" :src="data[indextr].approver.photoUrl" /></div>
                            <div v-else><vs-avatar  class="border-2 border-white border-solid -m-1" size="30px" :text="data[indextr].approver.fullName" :color="data[indextr].approver.fullName.length < 12 ? 'success' : data[indextr].approver.fullName.length <= 15 ? 'primary' : data[indextr].approver.fullName.length <= 20 ? 'warning' : 'danger'" /></div>
                            
                            <!-- <vs-avatar class="rounded-full shadow-md cursor-pointer block" size="medium" :src="data[indextr].approver.photoUrl" /> -->
                        </vx-tooltip>
                    </vs-td>
                    <vs-td  :data="data[indextr].photoId" >
                        <vs-icon v-show="data[indextr].photoId != '' && data[indextr].photoId != null" @click="downloadFile(data[indextr].photoId)"  color="primary" icon-pack="feather" icon="icon-paperclip"  />
                    </vs-td>
                    <vs-td :data="data[indextr].IsReviewerUnread">
                        <span class="flex items-center px-2 py-1 rounded"><div v-bind:class="
                            data[indextr].isCancelled == true ? 'h-3 w-3 rounded-full mr-2 bg-danger' :
                            data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                            data[indextr].isSubmitted == true && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false
                                                              && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverRetracked == false && data[indextr].isApproverDenied == false ? 'h-3 w-3 rounded-full mr-2 bg-warning' : 
                            data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverRetracked == false && data[indextr].isApproverDenied == false ? 'h-3 w-3 rounded-full mr-2 bg-warning' : 
                            data[indextr].isApproverApproved == true ? 'h-3 w-3 rounded-full mr-2 bg-success' :
                            data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                            data[indextr].isRetracted == true || data[indextr].isApproverRetracked == true ? 'h-3 w-3 rounded-full mr-2 bg-dark' :
                            data[indextr].isReviewerDenied == true || data[indextr].isApproverDenied == true ? 'h-3 w-3 rounded-full mr-2 bg-danger' : ''"/>
                                {{data[indextr].isCancelled == true ? 'Cancelled' :
                                 data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'Draft': 
                                 data[indextr].isSubmitted == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverRetracked == false && data[indextr].isApproverDenied == false  
                                                                   && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false ? 'For Review' :
                                 data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverRetracked == false && data[indextr].isApproverDenied == false ? 'Reviewed - For Approval' :
                                 data[indextr].isApproverApproved == true ? 'Approved' :
                                 data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true ? 'For Revision' :
                                 data[indextr].isRetracted == true || data[indextr].isApproverRetracked == true ? 'Retracted' :
                                 data[indextr].isReviewerDenied == true || data[indextr].isApproverDenied == true ? 'Denied' : ''}}
                        </span>                                                             
                    </vs-td>
                    <vs-td :data="data[indextr].reviewerComment">
                        {{data[indextr].reviewerComment}}
                    </vs-td>
                    <vs-td>
                        <div class="vx-row" v-if="!data[indextr].isRetracted">
                            <div class="flex">
                                <vx-tooltip v-if="data[indextr].reviewerId == currentUserId && (data[indextr].isSubmitted == true || data[indextr].isRetracted == true) && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false  && data[indextr].isReviewerDenied== false" text="Review">
                                    <vs-button class="mr-3 mb-2" @click="onReviewed(data[indextr].employeeFiledLoansId)" v-if="(data[indextr].isSubmitted == true || data[indextr].isRetracted == true) && data[indextr].isReviewerApproved == false & data[indextr].isReviewerRevised == false  && data[indextr].isReviewerDenied== false" color="success" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                                </vx-tooltip>
                                <vx-tooltip v-if="data[indextr].approverId == currentUserId && (data[indextr].isSubmitted == true || data[indextr].isApproverRetracked == true) && data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false  && data[indextr].isApproverDenied== false" text="Approve">
                                    <vs-button class="mr-3 mb-2" @click="onApproved(data[indextr].employeeFiledLoansId)" v-if="(data[indextr].isSubmitted == true || data[indextr].isApproverRetracked == true) && data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false  && data[indextr].isApproverDenied== false" color="success" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                                </vx-tooltip>
                            </div>
                            <div class="flex">
                                <vx-tooltip v-if="data[indextr].reviewerId == currentUserId && (data[indextr].isSubmitted == true || data[indextr].isRetracted == true) && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false  && data[indextr].isReviewerDenied== false"  text="Deny">
                                    <vs-button class="mr-3 mb-2" @click="promptDeniedDialog(data[indextr].employeeFiledLoansId)" v-if="(data[indextr].isSubmitted == true || data[indextr].isRetracted == true) && data[indextr].isReviewerApproved == false & data[indextr].isReviewerRevised == false && data[indextr].isReviewerDenied== false" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                                </vx-tooltip>
                                <vx-tooltip v-if="data[indextr].approverId == currentUserId && (data[indextr].isSubmitted == true || data[indextr].isApproverRetracked == true) && data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false  && data[indextr].isApproverDenied== false" text="Deny">
                                    <vs-button class="mr-3 mb-2" @click="promptApproverDeniedDialog(data[indextr].employeeFiledLoansId)" v-if="(data[indextr].isSubmitted == true || data[indextr].isApproverRetracked == true) && data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false  && data[indextr].isApproverDenied== false" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                                </vx-tooltip>
                            </div>
                            <div class="flex">
                                <vx-tooltip v-if="data[indextr].reviewerId == currentUserId && (data[indextr].isSubmitted == true || data[indextr].isRetracted == true) && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false  && data[indextr].isReviewerDenied== false" text="Revise">
                                    <vs-button class="mb-2" @click="promptRevisionDialog(data[indextr].employeeFiledLoansId)" v-if="(data[indextr].isSubmitted == true || data[indextr].isRetracted == true) && data[indextr].isReviewerApproved == false & data[indextr].isReviewerRevised == false && data[indextr].isReviewerDenied== false" color="warning" type="border" icon-pack="feather" icon="icon-triangle"></vs-button>
                                </vx-tooltip>
                                 <vx-tooltip v-if="data[indextr].approverId == currentUserId && (data[indextr].isSubmitted == true || data[indextr].isApproverRetracked == true) && data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false  && data[indextr].isApproverDenied== false" text="Revise">
                                    <vs-button class="mr-3 mb-2" @click="promptApproverRevisionDialog(data[indextr].employeeFiledLoansId)" v-if="(data[indextr].isSubmitted == true || data[indextr].isApproverRetracked == true) && data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false  && data[indextr].isApproverDenied== false" color="warning" type="border" icon-pack="feather" icon="icon-triangle"></vs-button>
                                </vx-tooltip>
                            </div>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>


         <!-- DENIED ADD COMMENT -->
        <vs-prompt
            title = " Loan Deny"
            @accept="onReviewerDenied"
            accept-text= "Yes"
            :active.sync="activeDeniedDialog">
            <div class="con-exemple-prompt">
               Please leave a <b>remarks</b> to continue.
            <vs-input placeholder="Remarks" v-model="reviewerComment" class="mt-4 mb-2 w-full" />
            <vs-alert :vs-active="!validRemarks" color="danger" vs-icon="new_releases" >
                This can not be empty please enter remarks
            </vs-alert>
            </div>
        </vs-prompt>    

         <!-- REVISION ADD COMMENT -->
        <vs-prompt
            title = "Loan Revision"
            @accept="onReviewerForRevision"
            accept-text= "Yes"
            :active.sync="activeRevisionDialog">
            <div class="con-exemple-prompt">
               Please leave a <b>remarks</b> to continue.
            <vs-input placeholder="Remarks" v-model="reviewerComment" class="mt-4 mb-2 w-full" />
            <vs-alert :vs-active="!validRemarks" color="danger" vs-icon="new_releases" >
                This can not be empty please enter remarks
            </vs-alert>
            </div>
        </vs-prompt> 

        <!-- APPROVER -->
         <!-- DENIED ADD COMMENT -->
        <vs-prompt
            title = " Loan Deny"
            @accept="onApproverDenied"
            accept-text= "Yes"
            :active.sync="activeApproverDeniedDialog">
            <div class="con-exemple-prompt">
               Please leave a <b>remarks</b> to continue.
            <vs-input placeholder="Remarks" v-model="approverComment" class="mt-4 mb-2 w-full" />
            <vs-alert :vs-active="!validRemarks" color="danger" vs-icon="new_releases" >
                This can not be empty please enter remarks
            </vs-alert>
            </div>
        </vs-prompt>    

         <!-- REVISION ADD COMMENT -->
        <vs-prompt
            title = "Loan Revision"
            @accept="onApproverForRevision"
            accept-text= "Yes"
            :active.sync="activeApproverRevisionDialog">
            <div class="con-exemple-prompt">
               Please leave a <b>remarks</b> to continue.
            <vs-input placeholder="Remarks" v-model="approverComment" class="mt-4 mb-2 w-full" />
            <vs-alert :vs-active="!validRemarks" color="danger" vs-icon="new_releases" >
                This can not be empty please enter remarks
            </vs-alert>
            </div>
        </vs-prompt> 
    <!-- </vx-card> -->
</div>  
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moduleLoans from '@/store/loans/moduleLoans.js'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
    data() {
        return {
            selected: [],
            employeeFiledLoansId: null,

            remarks: '',
            reviewerComment: '',
            approverComment: '',
            currentDate: new Date(),

            activeDeniedDialog: false,
            activeRevisionDialog: false,
            activeApproverDeniedDialog: false,
            activeApproverRevisionDialog: false,

            
        }
    },
    created() {
        this.$vs.loading()
        this.$store.registerModule('loans', moduleLoans)
        
        // this.onRefreshTables()
        this.$store.dispatch('lookup/getAllPeriodLookup').catch((err) => { console.log(err)})
        this.$store.dispatch('lookup/getAllLoanCategory')
        this.$store.dispatch('lookup/getAllLoanSubCategory')
        this.$store.dispatch('tenants/getAllSignatories', { tenantsId : this.$store.state.AppActiveUser.tenantsId })
        const payload = {
                    sortBy: 'CreatedOn',
                    sortOrder: 'Desc',
                    pageNumber: 1,
                    pageSize: -1,
                    isApprover: true
                }
                this.$store.dispatch('loans/getAllEmployeeLoans', payload)
                    .then(() => { this.$vs.loading.close() })
                    .catch((err) => { this.$vs.loading.close() 
                                      console.log(err)})
        
        
    },
    beforeDestroy () {
        this.$store.unregisterModule('loans')
    },
    computed: {
        employeeLoan() {
            return this.$store.state.loans.employeeFiledLoans
        },
        currentUserId(){
            return this.$store.state.AppActiveUser.uid
        },
        validRemarks(){
            return (this.remarks.length > 0)
        },
        loanCategoryName() {
            return (id) => this.$store.getters['lookup/loanCategoryLookup'](id) 
        },
        loanSubCategoryName() {
            return (id) => this.$store.getters['lookup/loanSubCategoryLookup'](id) 
        },
        periodName() {
            return (id) => this.$store.getters['lookup/periodLookup'](id)
        },
        termsTypeName(){            
            return (id) => this.$store.getters['lookup/termsTypeName'](id).label
        },
    },
    methods: {
        onReviewed(employeeFiledLoansId) {
                this.$vs.loading()
                const data = {
                    employeeFiledLoansId : employeeFiledLoansId,
                    action: "REVIEWED", 
                    IsReviewerUnread : false,
                    isReviewerApproved: true, 
                    reviewerApprovedOn : this.currentDate, 
                    isRetracted : false,
                    reviewerId: this.$store.state.AppActiveUser.uid 
                }
                this.$store.dispatch('loans/onReviewed', data)
                .then((response) => { 
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully reviewed loan request.", "Reviewed Successfully", "success")
                        else
                            this.$alert("", response.statusText, "error")
                    })
                .catch((error) => { 
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })


        },
        onApproved(employeeFiledLoansId) {
                this.$vs.loading()
                const data = {
                    employeeFiledLoansId : employeeFiledLoansId,
                    action: "APPROVERAPPROVED", 
                    isApproverUnread : false, 
                    isApproverApproved: true, 
                    approverApprovedOn : this.currentDate, 
                    isApproverRetracked : false,
                    approverId: this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('loans/onApproved', data)
                .then((response) => { 
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully approved loan request.", "Approved Successfully", "success")
                        else
                            this.$alert("", response.statusText, "error")
                    })
                .catch((error) => { 
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })


        },
        onReviewerDenied() {
                this.$vs.loading()
                const data = {
                    employeeFiledLoansId : this.employeeFiledLoansId,
                    action: "DENIED", 
                    isReviewerUnread : false, 
                    isReviewerDenied: true, 
                    reviewerDeniedOn : this.currentDate, 
                    isRetracted : false, 
                    reviewerComments : this.reviewerComment,
                    reviewerId: this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('loans/onReviewerDenied', data)
                .then((response) => { 
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully denied loan request.", "Denied Successfully", "success")
                        else
                            this.$alert("", response.statusText, "error")
                    })
                .catch((error) => { 
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })


        },
        onApproverDenied() {
                this.$vs.loading()
                const data = {
                    employeeFiledLoansId : this.employeeFiledLoansId,
                    action: "APPROVERDENIED", 
                    isApproverUnread : false, 
                    isApproverDenied: true, 
                    approverDeniedOn : this.currentDate, 
                    isApproverRetracked : false, 
                    approverComments : this.approverComment,
                    approverId: this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('loans/onApproverDenied', data)
                .then((response) => { 
                        this.$vs.loading.close()
                       if(response.status == 200)
                            this.$alert("You have successfully denied loan request.", "Denied Successfully", "success")
                        else
                            this.$alert("", response.statusText, "error")
                    })
                .catch((error) => { 
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })


        },
        onReviewerForRevision() {
                this.$vs.loading()
                const data = {
                    employeeFiledLoansId : this.employeeFiledLoansId,
                    action: "REVISED", 
                    isReviewerUnread : false, 
                    isReviewerRevised: true, 
                    reviewerForRevisionOn : this.currentDate, 
                    isRetracted : false, 
                    reviewerComments : this.reviewerComment,
                    reviewerId: this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('loans/onReviewerRevised', data)
                .then((response) => { 
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully asked for loan request revision.", "Asking for Revision Successfully", "success")
                        else
                            this.$alert("", response.statusText, "error")
                    })
                .catch((error) => { 
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })


        },
        onApproverForRevision() {
                this.$vs.loading()
                const data = {
                    employeeFiledLoansId : this.employeeFiledLoansId,
                    action: "APPROVERREVISED", 
                    isApproverUnread : false, 
                    isApproverRevised: true, 
                    approverForRevisionOn : this.currentDate, 
                    isApproverRetracked : false, 
                    approverComments : this.approverComment,
                    approverId: this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('loans/onApproverRevised', data)
                .then((response) => { 
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully asked for loan request revision.", "Asking for Revision Successfully", "success")
                        else
                            this.$alert("", response.statusText, "error")
                    })
                .catch((error) => { 
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })


        },
        downloadFile(fileId){
            this.$store.dispatch('downloadFile', fileId)
                .then((response) => {
                    // console.log(response.headers['content-disposition'].split('filename=')[1].split('\;')[0])
                    let fileName = response.headers['content-disposition'].split('filename=')[1].split('\;')[0]
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName.replace('"', '').replace('"', '')
                    // link.setAttribute('download', fileName )
                    // document.body.appendChild(link);
                    link.click();
                })
        },
        promptDeniedDialog(Id) {
            this.remarks = ''
            this.employeeFiledLoansId = Id
            this.activeDeniedDialog = true
        },
        promptRevisionDialog(Id) {
            this.remarks = ''
            this.employeeFiledLoansId = Id
            this.activeRevisionDialog = true
        },
        promptApproverDeniedDialog(Id) {
            this.remarks = ''
            this.employeeFiledLoansId = Id
            this.activeApproverDeniedDialog = true
        },
        promptApproverRevisionDialog(Id) {
            this.remarks = ''
            this.employeeFiledLoansId = Id
            this.activeApproverRevisionDialog = true
        },
    }
    
}
</script>

